import { SharedModule } from './../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ChangeProfileComponent } from './change-profile/change-profile.component';
import { KycPendingComponent } from './kyc-pending/kyc-pending.component';
import { KycComponent } from './kyc/kyc.component' ;
import { AuthGuardService } from '../guards/auth-guard.service';
import { LoginGuardService } from '../guards/login-guard.service';

@NgModule({
  declarations: [LoginComponent, RegisterComponent, ChangeProfileComponent, KycPendingComponent, KycComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    SharedModule,
    RouterModule.forChild([
      {path: 'login', component: LoginComponent,canActivate: [LoginGuardService]},
      {path: 'register', component: RegisterComponent,canActivate: [LoginGuardService]},
      // { path: 'kyc' , component: KycComponent,canActivate: [AuthGuardService]},
      { path: 'changeProfile' , component: ChangeProfileComponent,canActivate: [AuthGuardService]},
      // { path: 'kycpending' , component: KycPendingComponent}
    ])
  ]
})
export class AuthModule { }
